"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.holidayDates = exports.HolidayType = exports.SessionDayType = void 0;
/**
 * Session Day Types
 */
var SessionDayType;
(function (SessionDayType) {
    SessionDayType["First"] = "1st day";
    SessionDayType["Consecutive"] = "consecutive";
    SessionDayType["NonConsecutive"] = "non-consecutive";
    SessionDayType["Saturday"] = "Saturday";
    SessionDayType["Sunday"] = "Sunday";
    SessionDayType["Holiday"] = "Holiday";
})(SessionDayType || (exports.SessionDayType = SessionDayType = {}));
/**
 * Holiday Types
 */
var HolidayType;
(function (HolidayType) {
    HolidayType["NewYearsDay"] = "New Year's Day";
    HolidayType["MLKJrBirthday"] = "Martin Luther King Jr.'s Birthday";
    HolidayType["PresidentsDay"] = "Presidents' Day";
    HolidayType["MemorialDay"] = "Memorial Day";
    HolidayType["Juneteenth"] = "Juneteenth";
    HolidayType["IndependenceDay"] = "Independence Day";
    HolidayType["LaborDay"] = "Labor Day";
    HolidayType["VeteransDay"] = "Veterans Day";
    HolidayType["ThanksgivingDay"] = "Thanksgiving Day";
    HolidayType["ChristmasDay"] = "Christmas Day";
})(HolidayType || (exports.HolidayType = HolidayType = {}));
exports.holidayDates = {
    1: [
        { name: HolidayType.NewYearsDay, day: 1 },
        {
            name: HolidayType.MLKJrBirthday,
            weekday: 1, // [just another] floating monday
            days: [15, 21],
        },
    ],
    2: [
        {
            name: HolidayType.PresidentsDay,
            weekday: 1,
            days: [15, 21],
        },
    ],
    5: [
        {
            name: HolidayType.MemorialDay,
            weekday: 1,
            days: [25, 31],
        },
    ],
    7: [
        {
            name: HolidayType.IndependenceDay,
            day: 4,
        },
    ],
    9: [
        {
            name: HolidayType.LaborDay,
            weekday: 1,
            days: [1, 7],
        },
    ],
    11: [
        {
            name: HolidayType.VeteransDay,
            day: 11,
        },
        {
            name: HolidayType.ThanksgivingDay,
            weekday: 4, // [just another] floating thursday
            days: [22, 28],
        },
    ],
    12: [
        {
            name: HolidayType.ChristmasDay,
            day: 25,
        },
    ],
};
//# sourceMappingURL=session-types.js.map